import { render, staticRenderFns } from "./AddNotificacionToUserPage.vue?vue&type=template&id=2f8f6d98"
import script from "./AddNotificacionToUserPage.vue?vue&type=script&lang=js"
export * from "./AddNotificacionToUserPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports